import HeartIcon from "../common/heart";
import AlarmButton from "./alarm-button";
import TransitionWrapper from "../common/transition-wrapper";
import ResponsiveCDNImage from "../common/image/responsive-cdn-image";
import { FaHeart } from "react-icons/fa";
import NewTag from "./new-tag";
import { StoreCoupon } from "./types";
import { CouponBadge } from "./coupon-badge";

interface IProp {
  onClick: () => void;
  onClickHeart?: (e: React.MouseEvent) => void;
  quantity?: number | undefined;
  title: string;
  closingHours: string;
  discountPrice?: number | null | undefined;
  price?: number | null | undefined;
  isLiked?: boolean | undefined | null;
  img: string;
  distance?: number | null;
  disableLike?: boolean;
  likeCount?: number;
  signupDate?: Date;
  availableStoreCoupon?: StoreCoupon;
}

export const StoreCardForTimesailYet = ({
  quantity,
  title,
  closingHours,
  discountPrice,
  price,
  onClick,
  onClickHeart,
  img,
  isLiked,
  distance,
  disableLike = false,
  likeCount,
  signupDate,
  availableStoreCoupon,
}: IProp): JSX.Element => {
  return (
    <TransitionWrapper
      scale={0.9}
      opacity={0.9}
      className="w-full h-56"
      onClick={onClick}
    >
      <div className="w-full h-full">
        <div className="relative w-full h-full bg-white rounded-[10px] overflow-hidden shadow-[0px_3px_8px_#0000000d]">
          {/* Upper Box */}
          <div className="absolute w-full h-[8.75rem]">
            <ResponsiveCDNImage
              src={img}
              alt={title}
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-black to-transparent opacity-30"></div>
            {quantity !== undefined && quantity !== 0 && (
              <div className="absolute bottom-0 right-0 bg-black text-white p-2 px-2.5">
                <p className="text-base ">{quantity}개 남았어요!</p>
              </div>
            )}
            <div className="absolute bottom-2 left-4 right-4 font-bold text-white z-10 text-xl flex items-center min-w-0">
              <div className="flex items-center gap-2 min-w-0">
                <span className="truncate">{title}</span>
                <span className="flex-shrink-0">
                  <NewTag signupDate={signupDate} />
                </span>
              </div>
            </div>

            {/* Heart Icon */}
            {!disableLike && (
              <div className="absolute top-2 right-2 z-20">
                <HeartIcon onClick={onClickHeart} isLiked={isLiked} />
              </div>
            )}
          </div>

          {/* 쿠폰 칩 - Upper box와 Lower box 사이 */}
          {availableStoreCoupon && (
            <div className="absolute w-full left-0 px-4 top-36">
              <div className="flex justify-center">
                <CouponBadge coupon={availableStoreCoupon} />
              </div>
            </div>
          )}

          {/* Lower Box */}
          <div className="absolute w-full bottom-5 left-0 px-4 flex justify-between items-center gap-1">
            <div className="flex flex-col justify-center w-full">
              <p className="flex gap-1 items-end font-semibold text-black text-lg w-full">
                <span className="truncate">{title} </span>
                {likeCount && likeCount > 0 ? (
                  <span className="text-gray-500 text-sm flex-shrink-0 flex items-center gap-1 pb-0.5">
                    (<FaHeart className="w-4 h-4 text-[#1562fc]" />{" "}
                    <p className="">{likeCount}</p>)
                  </span>
                ) : null}
              </p>
              <div className="flex items-center mt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  className="mr-[1px] mt-[1px]"
                >
                  <path
                    d="M5.5 3.5V5.5L7 7M10 5.5C10 6.09095 9.8836 6.67611 9.65746 7.22208C9.43131 7.76804 9.09984 8.26412 8.68198 8.68198C8.26412 9.09984 7.76804 9.43131 7.22208 9.65746C6.67611 9.8836 6.09095 10 5.5 10C4.90905 10 4.32389 9.8836 3.77792 9.65746C3.23196 9.43131 2.73588 9.09984 2.31802 8.68198C1.90016 8.26412 1.56869 7.76804 1.34254 7.22208C1.1164 6.67611 1 6.09095 1 5.5C1 4.30653 1.47411 3.16193 2.31802 2.31802C3.16193 1.47411 4.30653 1 5.5 1C6.69347 1 7.83807 1.47411 8.68198 2.31802C9.52589 3.16193 10 4.30653 10 5.5Z"
                    stroke="#585858"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p className="text-sm text-gray-600">
                  <span className="font-medium text-base">
                    {closingHours}까지
                  </span>{" "}
                  <span className="text-[#b6b6b6]">
                    {distance ? distance?.toFixed(2) + "km" : ""}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex flex-col items-end justify-center flex-shrink-0">
              <p className="font-bold text-black text-xl">
                {discountPrice ? `~${discountPrice?.toLocaleString()}원` : null}
              </p>
              {price ? (
                <div className="text-xs text-gray-400 line-through">
                  ~{price?.toLocaleString()}원
                </div>
              ) : (
                <>
                  {!disableLike && (
                    <AlarmButton onClick={onClickHeart} isLiked={isLiked} />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </TransitionWrapper>
  );
};
